import { getAxiosClient } from "../../axios-client";
import { GetUsersDataResponse } from "./types";

const axiosClient = getAxiosClient();
export const getLoggedUsersData = async () => {
  return await axiosClient.ax.get<GetUsersDataResponse>("/Users/GetLogged");
};
